module.exports = __webpack_public_path__ + "static/media/chevronUp.c6a9f089.svg";